import { Injectable, inject } from '@angular/core';
import { APP_CONSTANTS, ApplicationType, BaseAppInitManagerService, IModuleModel, SharedAppActions, SharedAppState } from '@shared/core';
import { ModuleMapper } from '@shared/data';
import { CookieService } from 'ngx-cookie-service';
import { Observable, OperatorFunction, map, of, pipe, switchMap } from 'rxjs';
import { McaAppActions } from '../../infrastructure/store/mca-app/mca-app.actions';
import { McaAppState } from '../../infrastructure/store/mca-app/mca-app.state';
import { CookieHandler } from '../model/cookie-handler';
@Injectable({
    providedIn: 'root',
})
export class AppInitManagerService extends BaseAppInitManagerService {
    private readonly cookieService = inject(CookieService);
    private readonly appConstants = inject(APP_CONSTANTS);

    public override appInitError$ = this.store.select(SharedAppState.appInitError$);
    public override appModules$ = this.store.select(SharedAppState.appModules$);
    public override appPwaSettings$ = this.store.select(SharedAppState.appPwaSettings$);
    public override appType$ = this.store.select(McaAppState.applicationType$);

    public override setAppInitError(): Observable<void> {
        return this.store.dispatch(new SharedAppActions.SetAppInitError());
    }

    private loadAndSaveApplicationType(): OperatorFunction<void | null, ApplicationType> {
        return pipe(
            switchMap(() => {
                const cookieHandler = new CookieHandler(this.cookieService, this.appConstants);
                const cookieValue = cookieHandler.getMcaApplicationCookieValue();
                return of(cookieValue);
            }),
            switchMap(applicationType => {
                return this.store.dispatch(new McaAppActions.SetApplicationType(applicationType)).pipe(map(() => applicationType));
            }),
        );
    }

    public override loadAppModules(): Observable<IModuleModel[]> {
        return of(null).pipe(this.loadAndSaveApplicationType(), this.loadAndSaveAppModules());
    }

    private loadAndSaveAppModules(): OperatorFunction<ApplicationType, IModuleModel[]> {
        return pipe(
            switchMap(applicationType => this.appModulesClientService.getModules(null, applicationType)),
            switchMap(modules => {
                const mapper = new ModuleMapper();
                const mappedModules = mapper.mapModulesFromModulesDto(modules);
                return this.store.dispatch(new SharedAppActions.SetApplicationModules(mappedModules)).pipe(map(() => mappedModules));
            }),
        );
    }
}
